
export default {
  // methods: {
  //   showAccountAction() {
  //     const refAccountAction = this.$refs.refAccountAction;
  //     refAccountAction && refAccountAction.classList.toggle('show');
  //   },
  //   closeDropdown() {
  //     const refAccountAction = this.$refs.refAccountAction;
  //     refAccountAction && refAccountAction.classList.remove('show');
  //   },
  // },
};
